import React from "react";
import { FiShoppingCart, FiSettings, FiTrendingUp, FiSmartphone, FiGlobe, FiZap, FiLayers, FiUsers, FiCode, FiShield } from "react-icons/fi";
import {
  LuSettings,
  LuUsers,
  LuSmartphone,
  LuShieldCheck,
  LuPercent,
  LuShield,
  LuBuilding2,
  LuShoppingBag,
  LuClock,
  LuWallet,
  LuCpu,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

// 1. Hero Block Configuration
export const wooCommerceDevelopmentHeroData = {
  backgroundImage: "/images/serviceBanners/wooBanner.webp",
  whiteImage: "/images/serviceBanners/WooBannerW.webp",
  subTitle: "Creating High-Performance WooCommerce Stores",
  title: (
    <>
      Sell More with <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">WooCommerce Development</span> <br /> Solutions
    </>
  ),
  description:
    "WooCommerce stores built for performance, speed, and seamless shopping experience that enhance usability, improve store efficiency, and help businesses boost conversions and increase online revenue effectively.",
  primaryButton: {
    title: "Get Started",
    onClick: () => console.log("WooCommerce Start clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("WooCommerce Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast WooCommerce store optimized for better speed.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Works smoothly on all devices and screens.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Strong security with stable performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Easy to maintain and developer-friendly code structure.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(121,75,196,0.35)",
      iconGlow: "rgba(121,75,196,0.9)",
    },
  ],
};
// 2. Stats Block
export const wooCommerceStatsData = [
  {
    icon: LuShoppingBag,
    value: "300+",
    label: "WP Stores Built",
    colorClass: "text-[#794bc4]", // WooCommerce Brand Purple
    bgClass: "bg-[#794bc4]/10",
    borderClass: "border-[#794bc4]/20",
    glowClass: "shadow-[0_0_20px_rgba(121,75,196,0.15)]",
  },
  {
    icon: LuUsers,
    value: "180+",
    label: "Global Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Store Uptime",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Load Times",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const wooCommerceSolutionsAndProcessData = {
  buildSubtitle: "OUR ECOMMERCE EXPERTISE",
  buildTitle: "Custom WooCommerce Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform WooCommerce Solutions",
      desc: "Build fast and scalable stores for web and mobile platforms.",
      icon: FiLayers,
      colorClass: "text-[#794bc4]",
      bgClass: "bg-[#794bc4]/10",
      borderClass: "border-[#794bc4]/20 hover:border-[#794bc4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(121,75,196,0.25)]",
    },
    {
      title: "Enterprise WooCommerce Development",
      desc: "Secure and scalable eCommerce solutions for large businesses.",
      icon: FiCode,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce WooCommerce Development",
      desc: "Feature-rich online stores with smooth shopping experience.",
      icon: FiUsers,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand WooCommerce Solutions",
      desc: "Flexible store systems for dynamic product and order management.",
      icon: FiShield,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Secure WooCommerce Development",
      desc: "Strong security and reliable performance for online stores.",
      icon: FiShield,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom WooCommerce Solutions",
      desc: "Tailored WooCommerce development based on business needs.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR DEVELOPMENT ROADMAP",
  processTitle: "WooCommerce Development Process",
  processSteps: [
    { step: "01", title: "Discovery & Consultation", description: "Understand business goals, target audience, and store requirements.", icon: LuUsers },
    { step: "02", title: "Strategy & Planning", description: "Define store structure, features, and development roadmap.", icon: LuPalette },
    { step: "03", title: "UI/UX Design", description: "Create modern, user-friendly and conversion-focused store designs.", icon: LuCode },
    { step: "04", title: "Development", description: "Build scalable and high-performance WooCommerce stores.", icon: LuCode },
    { step: "05", title: "Quality Testing", description: "Ensure performance, security, and smooth user experience.", icon: LuRocket },
    { step: "06", title: "Deployment & Support", description: "Launch store and provide ongoing maintenance and improvements.", icon: LuRocket },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR WOOCOMMERCE SERVICES?",
  benefitsTitle: "Why Businesses Choose WooCommerce Development Solutions",
  benefits: [
    "Cross-platform support",
    "Faster development speed",
    "Modern UI design",
    "Smooth performance optimization",
    "Efficient workflow process",
    "Scalable WooCommerce solutions",
    "Cost-effective development approach",
  ],
  logoImage: "/images/serviceBanners/wooBanner.webp",
  whiteLogoImage: "/images/serviceBanners/WooBannerW.webp",
};

// 4. Portfolio Data
export const wooCommercePortfolioData = {
  subtitle: "OUR SUCCESS STORIES",
  title: "WooCommerce Stores Driving ROI",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "Artisan Marketplace",
      badge: "B2C E-com",
      badgeColor: "bg-[#794bc4]/10 text-[#794bc4] border-[#794bc4]/20",
      desc: "A custom WooCommerce build with automated vendor payouts and complex tax logic.",
      downloads: "Active",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1515168833906-d2a3b82b3029?auto=format&fit=crop&w=800&q=80",
    },
  ],
};

// 5. Technologies Data
export const wooCommerceTechnologiesData = {
  techTitle: "WOOCOMMERCE TOOL STACK",
  technologies: [
    { name: "WordPress", icon: "RestAPI" },
    { name: "WooCommerce Core", icon: "Code" },
    { name: "PHP / MySQL", icon: "SQLite" },
    { name: "REST API", icon: "RestAPI" },
    { name: "Stripe / PayPal", icon: "Provider" },
    { name: "WP Rocket", icon: "Zap" },
  ],
  trustTitle: "TRUSTED BY GROWTH-DRIVEN BRANDS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle" },
  ],
};

// 6. About Overview
export const wooCommerceAboutData = [
  {
    title: "WooCommerce Development Services for Scalable eCommerce Growth",
    content: (
      <>
        A successful online store depends on speed, flexibility, and a smooth customer experience. Reliable{" "}
        <b className="text-text-primary font-semibold">woocommerce development services</b> help businesses build scalable online stores that support product management, secure
        transactions, and stronger customer engagement. Many businesses face challenges with limited customization and poor shopping experiences that impact conversions. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, WooCommerce solutions are developed around business goals and customer expectations to help brands
        create practical, growth-focused eCommerce experiences.
      </>
    ),
  },
  {
    title: "WooCommerce Website Development for Better Shopping Experiences",
    content: (
      <>
        Online shoppers expect websites that are simple to navigate and easy to trust. Effective <b className="text-text-primary font-semibold">woocommerce website development</b>{" "}
        helps businesses improve user journeys, simplify product discovery, and create smoother purchasing experiences. Companies investing in{" "}
        <b className="text-text-primary font-semibold">custom woocommerce store development</b> often benefit from greater flexibility because stores can be tailored to match
        unique customer needs and operational workflows. Tycho Technologies focuses on building practical eCommerce systems designed to improve usability while supporting long-term
        digital growth.
      </>
    ),
  },
  {
    title: "WordPress Ecommerce Development That Supports Flexibility",
    content: (
      <>
        Businesses looking for adaptable online selling solutions often choose WordPress because of its flexibility and customization capabilities. Reliable{" "}
        <b className="text-text-primary font-semibold">wordpress ecommerce development</b> helps companies manage content, products, and customer experiences within one connected
        ecosystem. Organizations aiming to strengthen digital commerce often align their stores with{" "}
        <a href="https://tychotechnologies.com/wordpress-development-india" className="text-cyan-400 underline hover:text-cyan-300">
          wordpress development services
        </a>{" "}
        to improve website performance and create a stronger foundation for future growth.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a WooCommerce Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">woocommerce development company in india</b> continues to grow as businesses seek scalable and
        cost-effective eCommerce solutions. Companies working with <b className="text-text-primary font-semibold">woocommerce experts india</b> often prioritize flexibility, store
        performance, and better customer experiences. Businesses partnering with Tycho Technologies benefit from tailored WooCommerce frameworks designed around measurable business
        goals and growth opportunities. Many organizations also strengthen digital selling strategies through{" "}
        <a href="https://tychotechnologies.com/shopify-development-india" className="text-cyan-400 underline hover:text-cyan-300">
          shopify development services
        </a>{" "}
        to expand their eCommerce capabilities across platforms.
      </>
    ),
  },
];

// 7. FAQs (Preserved)
export const wooCommerceDevelopmentFaqs = [
  {
    q: "Why should I choose WooCommerce development for my online store?",
    a: "WooCommerce development helps businesses create customizable, scalable, and secure eCommerce stores on WordPress with seamless payment integration.",
  },
  {
    q: "Why hire WooCommerce developers in India?",
    a: "India offers cost-effective solutions with skilled developers who can build responsive, feature-rich, and optimized online stores for a smooth user experience.",
  },
];
